import { Suspense } from 'react';
import { useOverlayStore } from './overlay.store';

/**
 * 앱 루트(모든 provider 하위)에 1회 mount. `present()` 로 push 된 오버레이를 React 트리 안에서
 * 렌더 → Query/Api/Navigator context 가 그대로 전파된다 (createRoot 로 띄우면 별개 fiber 트리라
 * context 가 끊긴다). entry 마다 독립 `Suspense` 라 `React.lazy` 오버레이가 suspend 해도 형제가
 * 블랭크되지 않는다.
 */
export function OverlayHost() {
  const entries = useOverlayStore((s) => s.entries);
  const close = useOverlayStore((s) => s.close);

  return (
    <>
      {entries.map((entry) => (
        <Suspense key={entry.id} fallback={null}>
          {entry.render({ open: entry.open, close: () => close(entry.id) })}
        </Suspense>
      ))}
    </>
  );
}
